import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let MpfContactFrontendFeature = /*#__PURE__*/(() => {
  let MpfContactFrontendFeature = class MpfContactFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/contact/frontend","featureId":"mpf-contact"};
    }
    getFeatureFunctionality(functionality) {}
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfContactFrontendFeature_BaseFactory;
        return function MpfContactFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵMpfContactFrontendFeature_BaseFactory || (ɵMpfContactFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfContactFrontendFeature)))(__ngFactoryType__ || MpfContactFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfContactFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([
        // contact is superseded by request-demo page which defined in mpf-frontend app.
        // however request-demo  uses components from this package so it cannot be removed.
        // so as dirty workaround we're redirecting to the new page in here.
        {
          path: 'contact',
          redirectTo: '/request-demo'
        }
        // {path: 'contact', loadChildren: () => import('./contact-frontend.module').then(m=>m.ContactFrontendModule) }
        ])]
      });
    }
  };
  MpfContactFrontendFeature = __decorate([ClassName("MpfContactFrontendFeature")], MpfContactFrontendFeature);
  return MpfContactFrontendFeature;
})();
export { MpfContactFrontendFeature };